export default __webpack_public_path__ + "static/media/awaiting2.be737c31.svg";